module.exports = __webpack_public_path__ + "img/Tent_Meeting_Summer_1931.608c8b5f.jpg";